import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: black;
`;

export const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const BottomText = styled.p`
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 600;
    text-align: center;
    color: #FFF;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 1.5rem;
    font-style: normal;
    line-height: 120%; /* 1.8rem */
    letter-spacing: -0.03rem;
`;
